
// mutation types
export const SET_PAGINATE = "setPaginate";

const state = {
    paginate: {
        current_page: '',
        from: '',
        last_page: '',
        last_page_url: '',
        next_page_url: '',
        per_page: '',
        prev_page_url: '',
        to: '',
        total: '',
    },
};

const getters = {

    paginateGetters(state) {
        return state.paginate;
    },

};

const actions = {
};

const mutations = {

    [SET_PAGINATE](state, data) {
        state.paginate.current_page = data.current_page;
        state.paginate.from = data.from;
        state.paginate.last_page = data.last_page;
        state.paginate.last_page_url = data.last_page_url;
        state.paginate.next_page_url = data.next_page_url;
        state.paginate.per_page = data.per_page;
        state.paginate.prev_page_url = data.prev_page_url;
        state.paginate.to = data.to;
        state.paginate.total = data.total;
    },

};


export default {

    state,
    getters,
    actions,
    mutations,
}
